fx.ns("models", class Product extends fx.Model {

	constructor(data)
	{
        super(data);

        //this._layouts = new fx.ModelArray( this.medias.filter( (a) => a.model == "ThemeLayout").map( (a) => a.media) );
        
        //this._stickers = new fx.ModelArray( this.medias.filter( (a) => a.model == "Sticker").map( (a) => a.media) );

        //this._backgrounds = new fx.ModelArray( this.medias.filter( (a) => a.model == "Background").map( (a) => a.media) );

        //this._texts = new fx.ModelArray( this.medias.filter( (a) => a.model == "Text").map( (a) => a.media) );
    }

    get localized()
    {
        return true;
    }

    get propertiesNotStorable()
    {
        return [ "version"];
    }

    get defaults()
    {
        return { version:0, medias : new fx.ModelArray() };
    }

    get cover()
    {
        if (this.layouts.length > 0)
        {
            var d = this.layouts.find({isdefault : 1});
            return (d || this.layouts.getItemAt(0)).thumb;
        }
    }

    get layouts()
    {
        //return this._layouts;

        return this.medias.filter( (a) => a.model == "ThemeLayout" && a.media)
                          .sort( (a, b) => a.position - b.position)
                          .map( (a) => a.media);
    }

    get stickers()
    {
        return this.medias.filter( (a) => a.model == "Sticker")
                          .sort( (a, b) => a.position - b.position)
                            .map( (a) => a.media) ;
    }

    get backgrounds()
    {
        return this.medias.filter( (a) => a.model == "Background")
                          .sort( (a, b) => a.position - b.position)
                          .map( (a) => a.media) ;
    }

    get texts()
    {
        return this.medias.filter( (a) => a.model == "Text")
                          .sort( (a, b) => a.position - b.position)
                          .map( (a) => a.media) ;
    }

    delete(history)
    {
        this.medias.removeAll();
        super.delete(history);
    }

    onUpdated(action)
    {
        if (action.type != "init" && !action.impacts("version"))
            this.version++;

         // TODO : test this (for config when setting laytou as default, all other ones have to be unsetted)
         if (action.type == "update" && action.impactsOnly("isdefault") && action.tag == "update-default")
         {
            for(let i = 0; i < this.layouts.length; i++)
            {
                let layout = this.layouts.getItemAt(i);

                if (layout != action.model && layout.target == action.model.target)
                    layout.isdefault = 0;
            }
         }
    }

    addMedia(media)
    {
        if (!media) return;

        for (let i = 0; i < this.medias.length; i++)
        {
            let productMedia = this.medias.getItemAt(i);
            if (productMedia.media_id == media.id && productMedia.model == media.constructor.name)
                return;

        }
        
        // check if media not already existing
        let data = {};

        data.model = media.constructor.name;
        data.media_id = media.id;
        data.product_id = this.id;
        data.media = media;
        data.position = this.medias.length;
        
        this.medias.addItem( new models.ProductMedia(data) );
    }


    removeMedia(media)
    {
        for (let i = 0; i < this.medias.length; i++)
        {
            let productMedia = this.medias.getItemAt(i);
            if (productMedia.media_id == media.id && productMedia.model == media.constructor.name)
            {
                productMedia.delete();
                break;
            }
        }
    }

 
    updateUploadedMediaIds(newId, oldId)
    {
            for(let j = 0; j < this.medias.length; j++)
            {
                let media = this.medias.getItemAt(j);
                if (media.media_id == oldId)
                    media.media_id = newId;
            }
        
    }

    onDataEvent(e)
    {
        let media = e.model;
        let medias;
        let productMedia, index;

        switch(e.type)
        {
             case "text-saved" : 
             case "media-file-uploaded" :
                if (Utils.isID(e.model.oldid))
                    this.updateUploadedMediaIds(e.model.id, e.model.oldid);

                /*if (e.model instanceof models.Sticker || e.model instanceof models.Background)
                    this._getKeywords(e.model)
                break;*/

            case "position-up" : 
        
                medias = this.setMediaPositions(e.model.constructor.name);

                productMedia = medias.find({media : media});
                index = medias.indexOf( productMedia );
                if (index > 0)
                {
                    let previousProductMedia = medias.getItemAt( index - 1);
                    let actualPosition = productMedia.position;
                    productMedia.position = previousProductMedia.position;
                    previousProductMedia.position = actualPosition;

                    //this.updatePosition();
                    this.event("position-updated");
                }
            break;

            case "position-down" :
        
                medias = this.setMediaPositions(e.model.constructor.name);

                productMedia = medias.find({media : media});
                index = medias.indexOf( productMedia );
                if (index < medias.length-1)
                {
                    let previousProductMedia = medias.getItemAt( index + 1);
                    let actualPosition = productMedia.position;
                    productMedia.position = previousProductMedia.position;
                    previousProductMedia.position = actualPosition;

                    //this.updatePosition();
                    this.event("position-updated");
                }
                break;

            case "layout-saved" : 
                // let's check all stickers/backgrounds used
                let stickers = e.detail.stickers;
                let backgrounds = e.detail.backgrounds;

                for(let i = 0; i < stickers.length; i++)
                    this.addMedia( stickers.getItemAt(i ));

                for(let i = 0; i < backgrounds.length; i++)
                    this.addMedia( backgrounds.getItemAt(i ));
            break;

          

        }
    }


    setMediaPositions(type)
    {
        let medias = this.medias.filter( (a) => a.model == type && a.media).sort( (a, b) => a.position - b.position);
        for (let i = 0; i < medias.length; i++)
            medias.getItemAt(i).position = i;

        return medias;
    }


  
});